import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_REPORTS_TAGGING_CALL_VOLUME_GENERATE, URL_API_REPORTS_TAGGING_CALL_VOLUME_EXCEL} from '../apiHitFile';
import _ from 'lodash';
import ReportsViewParameterCallVolume from './ReportsViewParameterCallVolume';

class TaggingWiseCallVolumeIndex extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.actioninventoryUserMapped()
    this.props.resetReport()
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  componentWillReceiveProps = (nextProps) => {
    if(!_.isEqual(this.props.reportData, nextProps.reportData)){
      this.remakeHeader(nextProps.reportData)
    }
    if(!_.isEqual(this.props.mtdPer, nextProps.mtdPer)){
      this.remakeHeader(nextProps.reportData)
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(prevState.selectedCriteria !== this.state.selectedCriteria) {
      if(!_.isEmpty(this.props.reportData)){
        this.remakeHeader(this.props.reportData)
      }
    }
   }
  remakeHeader = (data) =>{
    const {selectedCriteria} = this.state
    if(!_.isEmpty(data)){
      let retundata=_.cloneDeep(data.header)
      if(selectedCriteria === 'Count'){
        let newdata = _.find(data.header, {"value":"parameterWiseScoreDetList"})
        if(typeof newdata  !== "undefined"){
        _.map(newdata.subHeaders, (obj) => {
          retundata.push(obj)
        })
        _.remove(retundata, {"value":"parameterWiseScoreDetList"})
        _.remove(retundata, {"value":"parameterWiseScoreDetListPer"})
        _.remove(retundata, {"value":"mtdPer"})
        data.header = retundata
        _.map(data.header,(obj,i)=>{
          if(_.has(obj, "subHeaders")){
            _.map(obj.subHeaders, (tt, i) => {   
                tt.label = "Count"
            })
          }
        })
        this.setState({setreportData:data})      
        } else {
          _.map(data.header,(obj,i)=>{
            if(_.has(obj, "subHeaders")){
              _.map(obj.subHeaders, (tt, i) => {   
                  tt.label = "Count"
              })
            }
          })
          this.setState({setreportData:data})
        }
      } else if(selectedCriteria === 'Percentage'){
        let newdata = _.find(data.header, {"value":"parameterWiseScoreDetListPer"})
        if(typeof newdata  !== "undefined"){
        _.map(newdata.subHeaders, (obj) => {
          retundata.push(obj)
        })
        _.remove(retundata, {"value":"parameterWiseScoreDetListPer"})
        _.remove(retundata, {"value":"parameterWiseScoreDetList"})
        _.remove(retundata, {"value":"mtd"})
        data.header = retundata
        _.map(data.header,(obj,i)=>{
          if(_.has(obj, "subHeaders")){
            _.map(obj.subHeaders, (tt, i) => {   
                tt.label = "Percentage"
            })
          }
        })
        this.setState({setreportData:data})      
        } else {
          _.map(data.header,(obj,i)=>{
            if(_.has(obj, "subHeaders")){
              _.map(obj.subHeaders, (tt, i) => {   
                  tt.label = "Percentage"
              })
            }
          })
          this.setState({setreportData:data})
        }
        
      }
    } else {
      this.setState({setreportData:[]})
    }
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName = []
    if(!_.isEmpty(selectedcenterName)){
        clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    }
    return clientName;
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
            processName = (selectedclientName.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
      }
    return processName;
  }  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[],GenerateReport:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], GenerateReport:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e}); 
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    }   
  }
  handleChangeStart = (date) => {
    this.setState({startDate: date});
  } 
  validateInput = () =>{
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, selectedCriteria, startDate} = this.state
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedprocessName) &&
    !_.isEmpty(selectedclientName) && typeof startDate !== "undefined" && !_.isEmpty(selectedCriteria)){
      return true
    }
  }
  generateReport = () => {
    const {selectedregionName, selectedcenterName, selectedclientName,selectedprocessName, startDate, selectedCriteria} = this.state
    let obj = {
       "region":selectedregionName.inventoryRegionName,
       "center":selectedcenterName.inventoryCenterName,
       "client":selectedclientName.inventoryClientName,
       "process":selectedprocessName.inventoryProcessName,
       "regionId":selectedregionName.inventoryRegionId,
      "centerId":selectedcenterName.inventoryCenterId,
      "clientId":selectedclientName.inventoryClientId,
      "processId":selectedprocessName.inventoryProcessId,
      "date":moment(startDate).format('YYYY-MM-DD'),
      "displayCriteria":selectedCriteria
      }
    // console.log('input', input)
    // let obj = {
    // "region":"India",
    // "center":"Dehardun",
    // "client":"VIL",
    // "process":"Inbound",
    // "date":"2019-07-16",
    // "displayCriteria":"count"
    // }
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_REPORTS_TAGGING_CALL_VOLUME_GENERATE)
    this.setState({GenerateReport:true})
    //this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedregionName, selectedcenterName, selectedclientName,selectedprocessName, startDate, selectedCriteria} = this.state
    let obj = {
       "region":selectedregionName.inventoryRegionName,
       "center":selectedcenterName.inventoryCenterName,
       "client":selectedclientName.inventoryClientName,
       "process":selectedprocessName.inventoryProcessName,
      "regionId":selectedregionName.inventoryRegionId,
      "centerId":selectedcenterName.inventoryCenterId,
      "clientId":selectedclientName.inventoryClientId,
      "processId":selectedprocessName.inventoryProcessId,
      "date":moment(startDate).format('YYYY-MM-DD'),
      "displayCriteria":selectedCriteria
      }
    // console.log('input', input)
    // let obj = {
    // "region":"India",
    // "center":"Dehardun",
    // "client":"VIL",
    // "process":"Inbound",
    // "date":"2019-07-16",
    // "displayCriteria":"count"
    // }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_REPORTS_TAGGING_CALL_VOLUME_EXCEL, "TAGGING_WISE_CALL_VOLUME.xlsx")
  }
  handleSelectCriteria = (e) => {
     const {GenerateReport} = this.state
     this.setState({selectedCriteria:e})
     if(GenerateReport === true) {
      //this.generateReport()
     } 
     
  }

	render(){
    const {GenerateReport, toggleA, selectedCriteria} = this.state; 
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }		
    let pickObj='parameterWiseScoreDetList'
    let mtdPer='mtd'
    if(selectedCriteria === 'Count'){
      pickObj='parameterWiseScoreDetList'
      mtdPer='mtd'
    } else {
      pickObj='parameterWiseScoreDetListPer'
      mtdPer='mtdPer'
    }
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
          <Col>
          <label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
          <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
          />
          </Col>
          <Col>
          <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Client'
          dropdownHeight={600}
          />
          </Col>        
          <Col> 
            <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
            <Picky keepOpen={false}
            value={this.state.selectedprocessName}
            options={this.processNames()}
            onChange={this.handleSelectProcess}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={false}
            includeSelectAll={true}
            includeFilter={false}
            placeholder='Select Process'
            dropdownHeight={600}
          /></Col>
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           endDate={this.state.endDate}
           onChange={this.handleChangeStart}
           maxDate={new Date()}
           placeholderText="Select Date"
          />
          </Col> 
       <Col> 
       <label><b>CRITERIA<span className="RedColoring"> *</span></b></label>     
       <Picky keepOpen={false}
        value={this.state.selectedCriteria}
        options={["Count", "Percentage"]}
        onChange={this.handleSelectCriteria}
        open={false}
        // valueKey="inventoryRegionName"
        // labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={false}
        placeholder='Select Criteria'
        dropdownHeight={600}
        /></Col>
      
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' disabled={!this.validateInput()}
          onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.state.setreportData) && !_.isEmpty(this.state.setreportData.value)) ? 
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> : null}
          {((GenerateReport === true) && !_.isEmpty(this.state.setreportData)) ?
           <ReportsViewParameterCallVolume  reportData={this.state.setreportData} pickObj={pickObj} mtdPer={mtdPer}/> 
          : null }
        </div> 
        </div>)
	}

}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    inventory: state.UserReducer.inventoryMapped, 
    reportData: state.ReportsReducer.reportData, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(TaggingWiseCallVolumeIndex);     